import { useEffect, useState } from 'react'

import { setStorageSerializedItem } from '../../../../../utils/storage'
import { readBirdviewStoredIds } from '../../../DashboardBirdview.utils.storage'

export function useBirdviewChartGridHidden({ defaultIds, ids, storageKey }) {
  const [hiddenIds, setHiddenIds] = useState(() =>
    readBirdviewStoredIds({ defaultIds, ids, storageKey })
  )

  useEffect(() => {
    setStorageSerializedItem(storageKey, hiddenIds)
  }, [hiddenIds, storageKey])

  function hideItem(id) {
    setHiddenIds(prev => (prev.includes(id) ? prev : [...prev, id]))
  }

  function showItem(id) {
    setHiddenIds(prev => prev.filter(hiddenId => hiddenId !== id))
  }

  return { hiddenIds, hideItem, showItem }
}
